import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 13,
    color: '#344054',
    marginBottom: 6,
    fontWeight: '500',
  },
  required: {
    color: '#F04438',
  },
  errorText: {
    fontSize: 12,
    color: '#F04438',
    marginTop: 4,
  },
  fieldLabel: {
    fontSize: 13,
    color: '#344054',
    marginBottom: 4,
    fontWeight: '400',
  },
  fieldValue: {
    fontSize: 15,
    color: '#1C1C1E',
    fontWeight: '600',
    marginBottom: 16,
  },
});
